module.exports = __webpack_public_path__ + "static/media/pago8.2ef23017.svg";